<template>
  <span class="svg-icon-arrow-down">
    <svg :width="width" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 4.92886L11 19.071C11 19.6233 11.4477 20.071 12 20.071C12.5523 20.071 13 19.6233 13 19.071L13 4.92886C13 4.37658 12.5523 3.92886 12 3.92886C11.4477 3.92886 11 4.37658 11 4.92886Z" :fill="color"/>
      <path d="M12 17.6568L5.63604 11.2928C5.24551 10.9023 4.61235 10.9023 4.22183 11.2928C3.8313 11.6833 3.8313 12.3165 4.22183 12.707L11.2929 19.7781C11.6834 20.1686 12.3166 20.1686 12.7071 19.7781L19.7782 12.707C20.1687 12.3165 20.1687 11.6833 19.7782 11.2928C19.3877 10.9023 18.7545 10.9023 18.364 11.2928L12 17.6568Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return '#FF2E38' } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean },
  }
}
</script>